import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { MASKS } from 'ng-brazil';
import { ComissaoComponent } from 'src/app/comissao/comissao.component';
import { Comissao } from 'src/app/models/comissao';
import { Funcionario } from 'src/app/models/funcionario';
import { ViaCep } from 'src/app/models/viacep';
import { AutenticacaoService } from 'src/app/services/autenticacao.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { ComissaoService } from 'src/app/services/comissao.service';
import { FuncionarioService } from 'src/app/services/funcionario.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { ViaCepService } from 'src/app/services/via-cep.service';
import { Location } from '@angular/common';
import { PerfilService } from 'src/app/services/perfil.service';
import { TelasModalComponent } from 'src/app/modals/telas-modal/telas-modal.component';
import { PremissasService } from 'src/app/services/premissas.service';
import { FornecedorService } from 'src/app/services/fornecedor.service';
import { Setor } from 'src/app/models/setor';
import { SetorService } from 'src/app/services/setor.service';
import { PremissasSistema } from 'src/app/models/premissas-sistema';
import { Fila } from 'src/app/models/filas/fila';
import { FilaService } from 'src/app/services/fila.service';

// jquery
declare const $: any;

@Component({
  selector: 'app-cadastrar-funcionario',
  templateUrl: './cadastrar-funcionario.component.html',
  styleUrls: ['./cadastrar-funcionario.component.scss']
})
export class CadastrarFuncionarioComponent implements OnInit, OnDestroy, AfterViewInit {
  // variáveis
  idFuncionario: number;
  funcionario = new Funcionario();
  editando = false;
  carregando = true;

  podeVerCustos = false;
  ativo = true;

  ehVendedor = false;
  nomeArquivo = '';
  comissoes: Comissao[] = [];

  public MASKS = MASKS;
  editavel = true;
  pegouFranquia = false;

  administrador = false;

  fornecedores = [];

  perfis = [
    { id: 0, nome: 'Operador' },
    { id: 1, nome: 'Administrador' }
  ];
  perfilSelecionado = undefined;

  estados = [
    'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI',
    'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'];
  estadoSelecionado = undefined;

  selectedFile: File;

  podeVerExcel = [
    { id: false, nome: 'Não' },
    { id: true, nome: 'Sim' },
  ];

  podeEditarVendaDireta = [
    { id: false, nome: 'Não' },
    { id: true, nome: 'Sim' },
  ];

  perfisDeAcesso = [];

  setores: Setor[] = [];

  usarCentroDeDistribuicao = false;
  podeVerEstoque = false;

  premissasSistems: PremissasSistema = new PremissasSistema();

  filas: Fila[] = [];

  constructor(
    private route: ActivatedRoute,
    private notificacaoService: NotificacaoService,
    private funcionarioService: FuncionarioService,
    private router: Router,
    private carregandoService: CarregandoService,
    private globalService: GlobalService,
    private autenticacaoService: AutenticacaoService,
    private viaCepService: ViaCepService,
    public dialog: MatDialog,
    private utilitarioService: UtilitarioService,
    private locationAngular: Location,
    private comissaoService: ComissaoService,
    private perfilService: PerfilService,
    private premissasService: PremissasService,
    private fornecedorService: FornecedorService,
    private setorService: SetorService,
    private filaService: FilaService
  ) { }

  async ngOnInit() {
    const userId = await (await this.globalService.consultaUsuario()).id;
    this.administrador = await this.globalService.administrador();
    this.buscarComissoes();
    this.buscarPerfisDeAcesso();
    this.buscarSetores();
    this.buscarPremissaCentroDeDistribuicao();
    this.consultaPodeVerEstoque(userId);

    this.buscarPremissasSistema();

    // se houver id, busca o funcionario referente
    if (this.route.snapshot.paramMap.get('id')) {
      this.idFuncionario = Number(this.route.snapshot.paramMap.get('id'));
      this.editando = true;
      this.buscarFuncionario();
    } else {
      this.funcionario = new Funcionario();
      this.funcionario.vendedor = 0;
      this.atualizaDadosFuncionario();
    }
  }

  consultaPodeVerEstoque(id: number) {
    this.carregandoService.mostra('podeVerEstoque');
    this.funcionarioService.consultaPodeVerEstoque(id).subscribe(resp => {
      this.podeVerEstoque = resp;
      this.carregandoService.esconde('podeVerEstoque');
    }, (erro) => {
      this.carregandoService.esconde('podeVerEstoque');
      console.error(erro);
      this.notificacaoService.erro('Não foi possível verificar se o usuário pode ver o estoque.');
    });
  }

  buscarPerfisDeAcesso() {
    this.carregandoService.mostra('buscarPerfisDeAcesso');

    this.perfilService.consultarPerfis().subscribe(
      (perfisDeAcesso) => {
        this.perfisDeAcesso = perfisDeAcesso;

        this.carregandoService.esconde('buscarPerfisDeAcesso');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPerfisDeAcesso');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarSetores() {
    this.carregandoService.mostra('buscarSetores');

    this.setorService.consultarSetores().subscribe((data: any) => {
      this.setores = data;
      this.carregandoService.esconde('buscarSetores');
    }, (erro) => {
      this.carregandoService.esconde('buscarSetores');
      this.notificacaoService.erro(erro);
    });
  }

  async telasDoUsuario() {
    this.carregandoService.mostra('buscarTelasDosPerfis');
    let telasDosPerfis = null;
    let relatoriosDosPerfis = null;

    telasDosPerfis = await this.perfilService.consultarTelasDosPerfis(this.funcionario.perfisDeAcesso).toPromise();
    relatoriosDosPerfis = await this.perfilService.consultarRelatoriosDosPerfis(this.funcionario.perfisDeAcesso).toPromise();

    this.carregandoService.esconde('buscarTelasDosPerfis');

    const dialogRef = this.dialog.open(TelasModalComponent, {
      width: ($('body').width()).toString() + 'px',
      data: {
        telas: this.funcionario.telasDeAcesso,
        relatorios: this.funcionario.relatoriosDeAcesso,
        telasDosPerfis: telasDosPerfis,
        relatoriosDosPerfis: relatoriosDosPerfis
      },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((resp) => {
      if (resp) {
        this.funcionario.telasDeAcesso = resp.telas;
        this.funcionario.relatoriosDeAcesso = resp.relatorios;
      }
    }
    );
  }

  buscarFuncionario() {
    this.carregandoService.mostra('buscaFuncionario');

    this.funcionarioService.consultarFuncionarioPorId(this.idFuncionario).subscribe(
      (prod) => {
        this.funcionario = prod;

        this.ehVendedor = this.funcionario.vendedor === 0;

        this.podeVerCustos = this.funcionario.verCustos === 'S';
        this.ativo = this.funcionario.situacao === true;
        this.atualizaDadosFuncionario();
      },
      (erro) => {
        this.carregandoService.esconde('buscaFuncionario');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarComissoes() {
    this.carregandoService.mostra('buscarComissoes');

    this.comissaoService.consultarComissoes().subscribe(
      (comissoes) => {
        this.comissoes = comissoes;

        this.carregandoService.esconde('buscarComissoes');
      },
      (erro) => {
        this.carregandoService.esconde('buscarComissoes');
        this.notificacaoService.erro(erro);
      }
    );
  }

  ngAfterViewInit(): void {
    this.rodaScriptTabEnter();
  }

  rodaScriptTabEnter() {
    this.utilitarioService.rodaScriptTabEnter();
  }

  atualizaDadosFuncionario() {


    this.perfilSelecionado = this.perfis.find(
      (s) => s.id === this.funcionario.status
    )
      ? this.perfis.find((s) => s.id === this.funcionario.status).id
      : 0;

    this.estadoSelecionado = this.estados.find(s => s === this.funcionario.estado);

    this.carregandoService.esconde('buscaFuncionario');
    this.carregando = false;
  }

  async salvar() {
    this.carregandoService.mostra('salvaFuncionario');
    this.funcionario.status = this.perfilSelecionado;
    this.funcionario.situacao = this.ativo;
    this.funcionario.estado = this.estadoSelecionado;


    if (this.perfilSelecionado === '1') {
      this.funcionario.perfisDeAcesso = [];
      this.funcionario.telasDeAcesso = [];
    }

    this.funcionario.verCustos = this.podeVerCustos ? 'S' : 'N';

    this.funcionario.vendedor = this.ehVendedor ? 0 : 1;

    if (this.selectedFile) {
      this.funcionario.fotoBase64 = (await this.utilitarioService.toBase64(this.selectedFile));
    }

    const funcionarioParaSalvar = Object.assign({}, this.funcionario);

    funcionarioParaSalvar.limDesc = Number(funcionarioParaSalvar.limDesc ? funcionarioParaSalvar.limDesc : 0);

    if (funcionarioParaSalvar.num !== undefined && funcionarioParaSalvar.num !== null) {
      funcionarioParaSalvar.num = Number(funcionarioParaSalvar.num);
    }

    this.funcionarioService.salvar(funcionarioParaSalvar).subscribe(
      (retorno) => {

        this.notificacaoService.sucesso('Usuário salvo com sucesso!!!');
        this.router.navigate(['configuracoes/usuarios']).then(() => {
          this.carregandoService.esconde('salvaFuncionario');
        });
      },
      (erro) => {
        this.carregandoService.esconde('salvaFuncionario');
        this.notificacaoService.erro(erro);
      }
    );
  }

  onFileChanged(event) {
    this.funcionario.foto = '';
    this.selectedFile = event.target.files[0];
    // this.carregandoService.mostra('converteImagem');
    // const file = event.target.files[0];
    // const reader = new FileReader();
    // reader.readAsBinaryString(file);
    // reader.onload = () => {
    //   this.funcionario.foto = reader.result.toString();
    //   this.carregandoService.esconde('converteImagem');
    // };


  }

  dataURItoBlob(dataURI) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/jpeg' });
    return blob;
  }

  ngOnDestroy(): void {

  }

  excluirArquivo() {
    this.selectedFile = undefined;
    this.funcionario.foto = '';
    this.funcionario.fotoBase64 = '';
  }

  buscarEnderecoPorCep() {

    if (!this.funcionario.cep || this.funcionario.cep.trim().replace('.', '').replace('-', '').length != 8)
      return;

    this.carregandoService.mostra('buscaEnderecoPorCep');
    this.viaCepService.obterEndereco(this.funcionario.cep).subscribe((viaCep: ViaCep) => {

      if (viaCep.erro) {
        this.carregandoService.esconde('buscaEnderecoPorCep');
        this.notificacaoService.erro('Nenhum registro encontrado para este CEP!!!');
        return;
      }

      this.funcionario.bairro = viaCep.bairro;
      this.funcionario.cidade = viaCep.localidade;
      //this.instalador.comp = viaCep.complemento;
      this.funcionario.endereco = viaCep.logradouro;
      this.estadoSelecionado = viaCep.uf;
      $('#numero').focus();

      this.carregandoService.esconde('buscaEnderecoPorCep');
    }, (erro) => {
      this.notificacaoService.erro('Não foi possível acessar o serviço de CEP!');
      this.carregandoService.esconde('buscaEnderecoPorCep');
    });
  }



  voltar() {
    this.locationAngular.back();
  }

  abrirComissoes() {

    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(ComissaoComponent, {
      width: (($('body').width()).toString() + 'px'),
      data: {},
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.buscarComissoes();
    });
  }

  buscarPremissaCentroDeDistribuicao() {
    this.carregandoService.mostra('buscarPremissaCentroDeDistribuicao');
    this.premissasService.consultarCentroDeDistribuicao().subscribe(
      centro => {
        this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
        if (centro.valor) {
          this.usarCentroDeDistribuicao = true;
          this.buscarFornecedores();
        }
      },
      err => {
        this.carregandoService.esconde('buscarPremissaCentroDeDistribuicao');
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarPremissasSistema() {
    this.carregandoService.mostra('buscarPremissasSistema');
    this.premissasService.consultarPremissasSistema().subscribe(
      premi => {
        this.premissasSistems = premi;
        this.carregandoService.esconde('buscarPremissasSistema');

        if (this.premissasSistems.usarFilasTarefas){
          this.buscarFilas();
        }
      },
      err => {
        this.carregandoService.esconde('buscarPremissasSistema');
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarFilas() {
    this.carregandoService.mostra('buscarFilas');
    this.filaService.consultarLista(1).subscribe(
      filas => {
        this.filas = filas;
        this.carregandoService.esconde('buscarFilas');
      },
      err => {
        this.carregandoService.esconde('buscarFilas');
        this.notificacaoService.erro(err);
      }
    );
  }

  buscarFornecedores() {
    this.carregandoService.mostra('buscarFornecedores');
    this.fornecedorService.consultarFornecedores().subscribe(
      forn => {
        this.carregandoService.esconde('buscarFornecedores');
        this.fornecedores = forn;
      },
      err => {
        this.carregandoService.esconde('buscarFornecedores');
        this.notificacaoService.erro(err);
      }
    );
  }

  verificaMax() {
    const isNullOrUndefined = (value: any) => value === null || value === undefined;

    if (!isNullOrUndefined(this.funcionario.limDesc)) {
      if (Number(this.funcionario.limDesc) > 100) {
        this.notificacaoService.erro('O valor máximo do campo Limite Desconto é 100.');
        this.funcionario.limDesc = 100;
      }
    }
  }
}
